import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AitColorPickerComponent } from './color-picker.component';
import { TuiFlatPickerModule, TuiLinearPickerModule } from '@taiga-ui/addon-editor';

@NgModule({
  imports: [CommonModule, TuiFlatPickerModule, TuiLinearPickerModule],
  declarations: [AitColorPickerComponent],
  exports: [AitColorPickerComponent]
})
export class AitColorPickerModule {}
